import { render, staticRenderFns } from "./VueTypeaheadBootstrapListItem.vue?vue&type=template&id=fb4b3f4e&scoped=true"
import script from "./VueTypeaheadBootstrapListItem.vue?vue&type=script&lang=js"
export * from "./VueTypeaheadBootstrapListItem.vue?vue&type=script&lang=js"
import style0 from "./VueTypeaheadBootstrapListItem.vue?vue&type=style&index=0&id=fb4b3f4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb4b3f4e",
  null
  
)

export default component.exports